import { FC, useMemo } from "react";
import { MeterDeliveryRequestFormSteps } from "components/forms";
import { ICreateMeterDeliveryRequest } from "components/forms";
import lodash from "lodash";
import {
  EnvelopeIcon,
  GlobeAltIcon,
  PhoneIcon,
} from "@heroicons/react/20/solid";


interface DeliveryRequestDetailsContainerProps {
  deliveryRequest: any;
  id: string;
  code: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

const DeliveryRequestDetailsContainer: FC<
  DeliveryRequestDetailsContainerProps
> = ({ code, deliveryRequest }) => {


  const values = useMemo<ICreateMeterDeliveryRequest>(
    () => ({
      contractInfo: {
        contractNumber: deliveryRequest?.request?.contractNumber,
        contractTitle: deliveryRequest?.request?.contractTitle,
        proposedStartDate: deliveryRequest?.request?.proposedStartDate,
        estimatedProductionCompletionDate: deliveryRequest?.request?.estimatedProductionCompletionDate,
        testAtOwnFacility: deliveryRequest?.request?.testAtOwnFacility,
      },
      metersInfo: {
        testSets: deliveryRequest?.request?.testSets?.map((testSet: any) => ({
          ...testSet,
          content: testSet?.content?.map((item: any, idx: number) => ({
            sn: idx + 1,
            ...item
          })) || []
        })) || [],
        singlePhaseMeterEnclosures: deliveryRequest?.request?.singlePhaseMeterEnclosures,
        threePhaseMeterEnclosures: deliveryRequest?.request?.threePhaseMeterEnclosures,
      }
    }),
    [deliveryRequest]
  );


  return (
    <div className='flex-1 flex flex-col overflow-hidden'>
      <div className='flex-1 flex flex-col overflow-hidden'>
        <div className='hidden print:flex flex-row items-center space-x-4 justify-center py-6 border-b border-gray-300'>
          <div>
            <img
              alt='ECG Logo'
              src={"/logo.png"}
              className='h-32 w-32'
            />
          </div>
          <div className='space-y-1 text-gray-900'>
            <h1 className='text-xl text-primary-600 font-bold'>
              ELECTRICITY COMPANY OF GHANA LIMITED
            </h1>
            <div className='flex items-center space-x-6'>
              <div className='flex items-center space-x-2'>
                <EnvelopeIcon className='h-4 w-4' />
                <span>P.O BOX GP 521, ACCRA</span>
              </div>
              <div className='flex items-center space-x-2'>
                <PhoneIcon className='h-4 w-4' />
                <span>0302-611-611</span>
              </div>
              <div className='flex items-center space-x-2'>
                <GlobeAltIcon className='h-4 w-4' />
                <span>ecg@ecggh.com</span>
              </div>
            </div>
            <div className='flex items-center space-x-6'>
              <div className='flex items-center space-x-2'>
                <span className='font-semibold'>VAT REG:</span>
                <span>714V000395</span>
              </div>
              <div className='flex items-center space-x-2'>
                <span className='font-semibold'>Website:</span>
                <span>https://www.ecggh.com/</span>
              </div>
            </div>
          </div>
        </div>
        <div className='space-y-6 divide-y divide-gray-200 p-6 overflow-y-auto flex-1'>
            {MeterDeliveryRequestFormSteps.map(({ SummaryComponent, ...summary }, idx: number) => (
              <div key={idx} className={idx === 0 ? " p-4" : " p-4 pt-6"}>
                <>
                  <div className='flex justify-between items-center cursor-pointer'>
                    <div>
                      <h3 className='text-md leading-6 font-normal text-gray-900 dark:text-gray-100'>
                        {summary?.name}
                      </h3>
                      <p className='mt-1 text-xs text-gray-500'>
                        {summary?.description}
                      </p>
                    </div>
                    <div />
                  </div>
                  <div className='mt-6'>
                    <SummaryComponent
                      data={lodash.get(values, summary?.accessor)}
                      values={values}
                      meterContractor={deliveryRequest?.meterContractor}
                    />
                  </div>
                </>
              </div>
            ))}
          </div>
      </div>

      <div className='bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:py-4 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200'>
      </div>
    </div>
  );
};

export default DeliveryRequestDetailsContainer;
